import { createSlice } from "@reduxjs/toolkit";

const initialState ={
isloading:false,
mstatus:"",
message:"",
uroles: {}
};

const userRoleModifySlice = createSlice({
    name:"userRoleModify",
    initialState,
    reducers:{
        modifyRolePending:(state,action) => {
            state.isloading=true;
            state.mstatus="";
        },
        modifyRoleSuccess:(state,{payload}) => {
            state.isloading=false;
            state.mstatus="success";
            state.uroles=payload;
            state.message="User Role Successfully Updated";
            console.log(payload);
        },
        modifyRoleFail:(state,{payload}) => {
            state.isloading=false;
            state.mstatus="fail";
           // console.log('slice '+payload);
            state.message=payload;
        }


    }
});

const {reducer,actions} = userRoleModifySlice;
export const{modifyRolePending,modifyRoleSuccess,modifyRoleFail}=actions;
export default reducer;

